
<div class="p-3">
    <div class="grid" (keydown.enter)="search()">
        <div class="col-5 md:col-3 text-right">
            <p-button icon="pi pi-refresh" label="Refresh" styleClass="p-button-secondary" class="" (onClick)="refreshIncidents()"></p-button>
        </div>
        <div class="col-7 md:col-3 text-left">
            <p-button icon="pi pi-plus-circle" label="Create New" styleClass="p-button-success" class="" (onClick)="createIncident()"></p-button>
        </div>
        <div class="col-8 md:col-4 text-right">
            <span class="p-input-icon-left max-w-full">
                <i class="pi pi-search"></i>
                <input type="text" pInputText class="max-w-full" [(ngModel)]="searchText" placeholder="Search Incidents"/>
            </span>
        </div>
        <div class="col-4 md:col-2 text-left">
            <p-button label="Search" (click)="search()" class="w-full"></p-button>
        </div>
    </div>
</div>

<p-table [value]="incidents" [scrollable]="true" scrollHeight="460px" [virtualScroll]="true" [virtualScrollItemSize]="153"
    [rows]="5" [loading]="loading" [lazy]="true" (onLazyLoad)="onLazyLoad($event)" [lazyLoadOnInit]="false">
    <ng-template pTemplate="body" let-incident>
        <tr (click)="viewIncident(incident)">
            <td>
                <div class="grid text-sm h-8rem overflow-hidden">
                    <div class="col-1 font-bold">
                        <div *ngIf="incident?.ticket?.status != undefined">
                            <i [ngClass]="setIncidentIconClass(incident?.ticket?.status)"></i>
                        </div>
                        <div *ngIf="hasNotes(incident)">
                            <i [ngClass]="setIncidentIconClass('Note')"></i>
                        </div>
                        <div *ngIf="hasAttachments(incident)">
                            <i [ngClass]="setIncidentIconClass('Attachment')"></i>
                        </div>
                    </div>
                    <div class="col-10">
                        <div class="formgrid grid">
                            <div class="col-4 font-bold">
                                {{incident.incidentId}}
                            </div>
                            <div class="col-8 text-right text-xs">
                                {{incident.dateCreated | date: "EEE, MM/dd/yy hh:mm a"}}
                            </div>
                            <div class="col-12 font-bold">
                                {{incident.instrumentName}}
                            </div>
                            <div class="col-12">
                                {{incident.userName}}
                            </div>
                            <div class="col-12 font-medium">
                                {{incident.subject}}
                            </div>
                            <div class="col-12">
                                {{incident.description}}
                            </div>
                        </div>
                    </div>
                    <div class="col-1 m-auto">
                        <div class="h-full">
                            <i class="pi pi-chevron-right"></i>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="New Incident" [(visible)]="newIncidentModal" [breakpoints]="{ '960px': '75vw' }" position="top" [modal]="true" [style]="{ width: '50vw'}" [draggable]="false" [resizable]="false">
    <div class="grid p-fluid flex flex-wrap">
        <div class="col-12 p-1">
            <label for="instrument">Instrument</label>
            <p-dropdown id="instrument" [options]="instruments" [(ngModel)]="selectedInstrument" optionLabel="name"
                [filter]="true" filterBy="name" [showClear]="true" placeholder="Select an Instrument" (onChange)="loadServiceCodes()"></p-dropdown>
        </div>
        <div class="col-12 p-1">
            <label for="outOfService">Out of Service</label>
            <p-checkbox id="outOfService" [(ngModel)]="outOfService" [binary]="true" inputId="outOfService" class="pl-2"></p-checkbox>
        </div>
        <div class="col-12 p-1">
            <label for="serviceCodes">Service Codes</label>
            <p-dropdown id="serviceCodes" [options]="serviceCodes" [(ngModel)]="selectedServiceCode" optionLabel="description" placeholder="Select a Service Code"></p-dropdown>
        </div>
        <div class="col-12 p-1">
            <label for="subject">Title</label>
            <input pInputText id="subject" [(ngModel)]="title"/>
        </div>
        <div class="col-12 p-1">
            <label for="summary">Summary</label>
            <textarea id="summary" rows="5" cols="30" pInputTextarea [(ngModel)]="summary"></textarea>
        </div>
        
        <div class="col-6 p-1">
            <p-button label="Cancel" styleClass="p-button-secondary" class="flex justify-content-center" (onClick)="newIncidentModal = false"></p-button>
        </div>
        <div class="col-6 p-1">
            <p-button icon="pi pi-save" label="Save" styleClass="p-button-primary" class="flex justify-content-center" (onClick)="saveIncident()" [disabled]="saveIncidentDisabled"></p-button>
        </div>
    </div>
</p-dialog>